var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('router-link',{attrs:{"to":{name: _vm.buttonTo}}},[_c('i',{staticClass:"fas fa-chevron-left fa-margin-right"}),_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }